/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 15/01/2021
 */

import * as SessionUtils from './../../../core/session_utils.js'

const addressCatalogRequest = () => {
    return {
        session_token:SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        catalog: 'state',
        municipality_id: 0,
        state_id: 19
    }
}

export default addressCatalogRequest;